import { toast } from 'react-toastify';

import i18n from 'shared/lib/i18n';

function fallbackCopyTextToClipboard(text) {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    const successful = document.execCommand('copy');
    successful
      ? toast.success(i18n.t('metaInfo.copied'))
      : toast.warn(i18n.t('metaInfo.unableToCopy'));
  } catch (err) {
    toast.warn(i18n.t('metaInfo.unableToCopy'));
  }

  document.body.removeChild(textArea);
}

export function copyTextToClipboard(text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(
    () => toast.success(i18n.t('metaInfo.copied')),
    () => toast.warn(i18n.t('metaInfo.unableToCopy')),
  );
}
